import React, { Fragment } from 'react';
import {
    LeftBoxContent,
    LeftBox,
    TopRow,
    OuterMargin,
    TopRowContainer,
    QRCodeContainer,
    QRCodeBox,
} from '../../App/pages/LeaderBoardsCarusel/style';
import { withRouter } from 'react-router-dom';
import { Icon } from '../Icons/Icons';
import { ProfileAvatar } from '../ProfileAvatar/ProfileAvatar';
import { Text } from '../../UI/Text';
import { generateSlugLink, generateQRCodeLink, displayInfo } from '../../../Utils';
import {
    DefaultSummaryContainer,
    WorkoutSummaryContainer,
    ScrollWrapper,
    QrCodeDescription,
    QRSubtitle,
} from './style';
import { handleLoginService } from '../../../Services/handleLocalStorage';
import { config } from '../../../Configurations';
import QRCode from 'qrcode.react';
import { Spinner } from '../Spiner/Spiner';
import { HoverableLink } from '../../Layouts';

class Wrapper extends React.Component {
    state = {
        qrCodeLink: null,
    };

    componentDidMount() {
        const {
            sliderInfo: slider,
            match: { params },
            userType,
        } = this.props;

        generateQRCodeLink(slider, params.profileId, userType).then(qrCodeLink => this.setState({ qrCodeLink }));
    }

    render() {
        const { children, name, image, id, hideDefault } = this.props;
        const { qrCodeLink } = this.state;
        const visitorProfileLink = `/${generateSlugLink({ name, id })}`;

        return (
            <LeftBox hideDefault={hideDefault}>
                <LeftBoxContent>
                    <TopRowContainer>
                        <TopRow>
                            <Icon.Box size={'35x20'}>
                                <Icon.Logo />
                            </Icon.Box>

                            {handleLoginService.isAuthenticated() && (
                                <Fragment>
                                    <OuterMargin margin={'0 0 0 20px'}>
                                        <HoverableLink to={visitorProfileLink}>
                                            <ProfileAvatar src={`${config.baseUrl}/${image}`} />
                                        </HoverableLink>
                                    </OuterMargin>
                                    <HoverableLink to={visitorProfileLink}>
                                        <Text marginLeft="10px" fontSize="16" weight="bold">
                                            {name}
                                        </Text>
                                    </HoverableLink>
                                </Fragment>
                            )}
                        </TopRow>
                    </TopRowContainer>
                    <ScrollWrapper>{children}</ScrollWrapper>
                    <QRCodeContainer>
                        <QRCodeBox isEmpty={qrCodeLink === null}>
                            {qrCodeLink !== null ? <QRCode value={qrCodeLink} size={86} /> : <Spinner />}
                        </QRCodeBox>
                        <QrCodeDescription>
                            <Text weight={'bold'} fontSize={18} uppercase={true}>
                                Join this leaderboard on Tona
                            </Text>
                            <QRSubtitle weight={100} fontSize={16} marginTop={'10px'}>
                                Point your camera at this QR code (new phones only) or download Tona on the app store
                            </QRSubtitle>
                        </QrCodeDescription>
                    </QRCodeContainer>
                </LeftBoxContent>
            </LeftBox>
        );
    }
}

Wrapper = withRouter(Wrapper);

const findLineBreaks = string => {
    let lines = string.split('\n');
    let fullString = lines.map(line => (
        <p>
            {line} <br />
        </p>
    ));
    return fullString;
};

const DefaultSummary = ({ sliderInfo }) => (
    <DefaultSummaryContainer>
        <Text weight={'500'}>{sliderInfo && sliderInfo.gym ? sliderInfo.gym.fullName : ''}</Text>

        <Text fontSize={40} weight={'bold'}>
            {sliderInfo && sliderInfo.name}
        </Text>

        <Text marginBottom={'16px'} weight={'500'}>
            {sliderInfo && displayInfo(sliderInfo)}
        </Text>

        {/* {sliderInfo.name === 'User Who Shares The Most' ? (
            <LaunchEventSummary />
        ) : (
            <Fragment>
                <Text weight="100" marginTop="15px" fontSize="22">
                    Visit www.tona.fit/beta
                </Text>
                <Text weight="100" marginTop="15px" fontSize="22">
                    Download Tona
                </Text>
                <Text weight="100" marginTop="15px" fontSize="22">
                    Record a workout
                </Text>
                {sliderInfo.gym.data && (
                    <Text weight="100" marginTop="15px" fontSize="22">
                        Tag {sliderInfo.gym.data.fullname}
                    </Text>
                )}
            </Fragment>
        )} */}
    </DefaultSummaryContainer>
);

const WorkoutSummary = ({ screenWidth, sliderInfo: { workout } }) => {
    const { exercises } = workout; // breakdownList

    const rounds = getJoinedRounds(getWorkoutRounds(exercises));

    return (
        <WorkoutSummaryContainer>
            {screenWidth === 'DESKTOP' && (
                <React.Fragment>
                    <Text weight={'500'}>{workout.gym ? workout.gym.fullName : ''}</Text>

                    <Text fontSize={40} weight={'bold'}>
                        {workout.title}
                    </Text>

                    <Text marginBottom={'16px'} weight={'500'}>
                        {displayInfo(workout)}
                    </Text>
                </React.Fragment>
            )}

            {workout.description && (
                <Text weight={100} fontSize={16} lineHeight={1.3} marginBottom="24px">
                    {findLineBreaks(workout.description)}
                </Text>
            )}

            {Object.keys(rounds).map((round, index) => {
                const currentRound = rounds[round];

                return (
                    <React.Fragment>
                        <Text key={`round_${index}`} marginTop="10px" weight="bold" fontSize={20}>
                            {currentRound.count} {currentRound.count === 1 ? 'round' : 'rounds'} of:
                        </Text>

                        {[...currentRound.sets.values()].map((set, index) => {
                            return (
                                <Text key={`set_${index}`} marginTop="10px" fontSize={18} weight={100}>
                                    {set.length} x{' '}
                                    {set[0].isDistanceRequired ? `${set[0].distance} km` : `${set[0].repsCount}`}{' '}
                                    {set[0].exerciseName}{' '}
                                    {set[0].isDistanceRequired
                                        ? ''
                                        : set[0].kgCount && `(${set[0].kgCount.toFixed(0)}kg)`}
                                </Text>
                            );
                        })}
                    </React.Fragment>
                );
            })}
        </WorkoutSummaryContainer>
    );
};

export const LeaderboardSummary = props => {
    return (
        <Wrapper {...props}>
            {props.sliderInfo.workout ? <WorkoutSummary {...props} /> : <DefaultSummary {...props} />}
        </Wrapper>
    );
};

const getWorkoutRounds = exercises => {
    // add round if the first round is not stated
    if (!exercises[0].isRound) {
        exercises.unshift({ isRound: true });
    }

    // filter excercises in order to remove resting which is not a round
    exercises = exercises.filter(exercise => {
        if (exercise.exerciseType === 'resting') {
            if (exercise.isRound) return exercise;
            else return null;
        } else {
            return exercise;
        }
    });

    // creating an array of rounds
    let previousRoundIndex = 1;
    let roundNumber = 1;
    let rounds = {};

    for (let i = 1; i < exercises.length; i++) {
        if (exercises[i].isRound || i === exercises.length - 1) {
            let round = [];

            if (i === exercises.length - 1) round = exercises.slice(previousRoundIndex, exercises.length);
            else round = exercises.slice(previousRoundIndex, i);

            rounds[roundNumber] = round;
            previousRoundIndex = i + 1;
            roundNumber++;
        }
    }

    return rounds;
};

// comparing if rounds are containing the same consequence of exercise ids
const compareRounds = (round1, round2) => {
    let firstRound = '';
    let secondRound = '';

    round1.forEach(exercise => {
        firstRound += `${exercise.exerciseId}`;
    });

    round2.forEach(exercise => {
        secondRound += `${exercise.exerciseId}`;
    });

    return firstRound === secondRound;
};

// joining similar rounds
const getJoinedRounds = rounds => {
    // in case there's one round - return this round
    if (Object.keys(rounds).length === 1) {
        return { 1: { count: 1, sets: getJoinedSets(rounds[1]) } };
    }

    // in case there're many rounds
    let roundNumber = 1;
    let similarRoundsNumber = 1;
    let joinedRounds = {};

    for (let i = 1; i < Object.keys(rounds).length; i++) {
        if (compareRounds(rounds[i], rounds[i + 1])) {
            similarRoundsNumber++;
            joinedRounds[roundNumber] = {
                count: similarRoundsNumber,
                sets: getJoinedSets(rounds[i]),
            };
        } else {
            joinedRounds[roundNumber] = { count: 1, sets: getJoinedSets(rounds[i]) };
            roundNumber++;
            similarRoundsNumber = 0;
        }
    }

    return joinedRounds;
};

// joining similar sets
const getJoinedSets = exercises => {
    // in case there's one exercise - return this exercise
    let groupedExercises = new Map();
    if (exercises.length === 1) {
        groupedExercises.set(exercises[0].exerciseId, [...exercises]);
        return groupedExercises;
    }

    // in case there're many exercises

    for (let i = 0; i < exercises.length; i++) {
        if (groupedExercises.hasOwnProperty(exercises[i].exerciseId)) continue;
        let grouped = exercises.filter(exercise => exercise.exerciseId === exercises[i].exerciseId);

        // for (let j = 0; j < grouped.length; j++) {
        //     if (moreGroupedExercises.hasOwnProperty(`${exercises[j].exercise_id}-${exercises[j].REPS_count}`)) continue;

        //     let moreGrouped = grouped.filter(exercise => exercise.REPS_count === exercises[j].REPS_count);

        //     moreGroupedExercises.set(`${exercises[j].exercise_id}-${exercises[j].REPS_count}`, [...moreGrouped]);
        // }
        // grouped = [...grouped, ...moreGrouped];

        groupedExercises.set(exercises[i].exerciseId, [...grouped]);
    }

    return groupedExercises;
};

LeaderboardSummary.defaultProps = {
    sliderInfo: {
        gym: {},
        workout: {
            exercises: {},
        },
    },
};



// WEBPACK FOOTER //
// ./src/UI/Components/LeaderboardSummary/LeaderboardSummary.js